import * as React from "react";
import Team from "../commons/model/Team";
import ModalModifyTeam from "./ModalModifyTeam";
import Country from "../commons/model/address/Country";
import SelectableOption from "../commons/model/SelectableOption";

interface TeamCardProps {
  team: Team;
  selected: boolean;
  onSelect: () => void;
  countries: Country[];
}

interface TeamCardState {
  displayModifyTeamModal: boolean;
}

export default class TeamCard extends React.Component<TeamCardProps, TeamCardState> {
  constructor(props: TeamCardProps) {
    super(props);
    this.state = {
      displayModifyTeamModal: false,
    };
    this.handleClose = this.handleClose.bind(this);
  }

  render() {
    const size = this.props.team.users.length;
    const membersLbl =
      size +
      " " +
      (size == 1 ? i18n["Page.CustomerSupport.Member"] : i18n["Page.CustomerSupport.Members"]);
    return (
      <>
        <div
          className={"team-card v-flex" + (this.props.selected ? " selected" : "")}
          onClick={this.props.onSelect}
        >
          <i
            className="ic_edit team-edition"
            onClick={() => this.setState({ displayModifyTeamModal: true })}
          />
          <div className="team-name">{this.props.team.name}</div>
          <div className="team-members">{membersLbl}</div>
          <div className="team-countries h-flex">
            {this.props.team.countries.map((country) => (
              <div className="team-country" key={country.i18n}>
                {country.i18n}
              </div>
            ))}
          </div>
        </div>
        {this.state.displayModifyTeamModal && (
          <ModalModifyTeam
            endpoint={this.props.team.urlTeamEdition}
            teamName={this.props.team.name}
            countries={this.getCountrySelection()}
            close={this.handleClose}
          />
        )}
      </>
    );
  }

  private getCountrySelection() {
    const countries = this.props.team.countries.map((country) => country.name);
    return this.props.countries.map(
      (country) =>
        new SelectableOption(country.name, country.i18n, countries.includes(country.name))
    );
  }

  private handleClose(reload: boolean) {
    if (reload) {
      document.location.reload();
    } else {
      this.setState({ displayModifyTeamModal: false });
    }
  }
}
